import React from 'react'

import OverviewFilters from '../../../react4xp/components/Idea/OverviewFilters'

function IdeasOverviewPart({title, pageSize, services, endpoint, filters, ideasLiked, startValues, strings, isLogged}) {
	return (
		<OverviewFilters
			title={title}
			endpoint={endpoint}
			services={services}
			filters={filters}
			ideasLiked={ideasLiked}
			startValues={startValues}
			strings={strings}
			isLogged={isLogged}
			section={{
				bgColor: 'white-dark'
			}}
		/>
	)
}

export default (props) => <IdeasOverviewPart {...props} />
